import React from 'react';
import HeroBanner from '@/ui/hero-banner/home';
import styles from './styles.module.scss';

const HeroBannerFreeToolsForManagers = () => (
  <HeroBanner className={styles['free-tools-for-managers-hero']} />
);

export default HeroBannerFreeToolsForManagers;
